import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    Label
} from "reactstrap";
import { Button } from "@material-ui/core";

export default props => {
    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>Delete Equipment</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <Label>Name</Label>
                        <p>
                            <b>{props.qr.name}</b>
                        </p>
                    </Col>
                    <Col>
                        <Label>Description</Label>
                        <p>
                            <b>{props.qr.description}</b>
                        </p>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button variant="contained" onClick={() => props.close()}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        props.setActivity('delete','equipment',props.qr.name)
                        props.removeQr(props.qrUID);
                        props.close();
                    }}
                >
                    Remove
                </Button>
            </ModalFooter>
        </Modal>
    );
};
